var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "#06003c"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2v46h36V14.594l-.281-.313-12-12L30.406 2zm2 2h20v12h12v30H9zm22 1.438L39.563 14H31z"
  })));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0iIzA2MDAzYyI+PHBhdGggZD0iTSA3IDIgTCA3IDQ4IEwgNDMgNDggTCA0MyAxNC41OTM3NSBMIDQyLjcxODc1IDE0LjI4MTI1IEwgMzAuNzE4NzUgMi4yODEyNSBMIDMwLjQwNjI1IDIgWiBNIDkgNCBMIDI5IDQgTCAyOSAxNiBMIDQxIDE2IEwgNDEgNDYgTCA5IDQ2IFogTSAzMSA1LjQzNzUgTCAzOS41NjI1IDE0IEwgMzEgMTQgWiIgZmlsbD0iIzA2MDAzYyIvPjwvc3ZnPgo=";
export { SvgFile as ReactComponent };